// eslint-disable-next-line
export const GLOBAL_COOKIE_MESSAGE =
    'Cookies help us improve our web content and deliver personalised content. By using this web site, you agree to our use of cookies.';
